import { MONTHS } from '../constants/app.constants';
import { UntypedFormGroup } from '@angular/forms';

export function getHumanReadableDateShort(date) {
  const d = new Date(date);
  const day = d.getDate();
  const month = d.getMonth();

  return `${day < 10 ? '0' + day : day} ${MONTHS[month].code}`;
}

export function getHumanReadableDate(date) {
  const d = new Date(date);
  const day = d.getDate();
  const month = d.getMonth();
  const year = d.getFullYear();

  return `${day < 10 ? '0' + day : day} ${MONTHS[month].code} ${year}`;
}

export function getHumanReadableTime(timestamp: string) {
  const date = new Date(timestamp);
  const minutes = date.getUTCMinutes();
  const hours = date.getHours();
  return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes
    }`;
}

export function copyToClipboard(text) {
  const selBox = document.createElement('input');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = text;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  return true;
}

export function validateForm(form: UntypedFormGroup) {
  for (let i in form.controls) {
    form.controls[i].markAsTouched();
  }
}

export function getObjectValue(obj, keyPath) {
  return keyPath.split('.').reduce((p, c) => (p && p[c]) || null, obj);
}

export const regex = {
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-z0-9](?:[a-z0-9-]*[a-z0-9])*\.[a-z0-9](?:[a-z0-9-]*[a-z0-9]){1,}$/i,
  url: /^((http)(s)?:\/\/)?[a-zA-Z0-9.\-_]*\.([a-zA-Z]+)$/,
  name: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
  phone: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
  zipCode: /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/,
  dni: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$|^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$|^[a-z]{3}[0-9]{6}[a-z]?$/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*(.)\1{2,}).{8,128}$/,
  cif: /^(X(-|\.)?0?\d{7}(-|\.)?[A-Z]|[A-Z](-|\.)?\d{7}(-|\.)?[0-9A-Z]|\d{8}(-|\.)?[A-Z])$/,
};

export function calculateDistance(coords1, coords2) {
  const { latitude: lat1, longitude: lon1 } = coords1;
  const { latitude: lat2, longitude: lon2 } = coords2;

  const radlat1 = Math.PI * lat1 / 180;
  const radlat2 = Math.PI * lat2 / 180;
  const theta = lon1 - lon2;
  const radtheta = Math.PI * theta / 180;

  let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = dist * 180 / Math.PI;
  dist = dist * 60 * 1.1515;
  // To Kilometers, To Meters
  dist = dist * 1.609344 * 1000;
  return dist
}
